import React, { useContext, useEffect, useState } from "react";
import PasajeroFormulario from "../../../ProcesoCompra/CargaPasajeros/PasajeroFormulario";

import { cdrAPI, toolsAPI } from "../../../../utils/funcionesAPI";
import LoaderFormal from "../../../Global/LoaderFormal";
import { toast } from "react-toastify";
import LayoutCompra from "../../../Global/LayoutCompra";
import { validarDatosPasajeros, calcularEdad, manejadorDeRespuesta, isLogged } from "../../../../utils/Tools";
import { CdrGlobalContext } from "../../../../context/cdrGlobalContext";
import { withRouter } from "react-router-dom";
import { SET_PASAJEROS_ADULTOS, SET_PASAJEROS_MENORES, SET_CDR_OFERTAS } from "../../../../context/constantes";
import get from "../../../../utils/get";

const CargaPasajerosCdr = (props) => {
  const [state, dispatch] = useContext(CdrGlobalContext);
  const { pasajerosAdultos, pasajerosMenores, productoSeleccionado, busquedaCDR } = state || {};
 
  if (!isLogged()) props.history.push("/hoteles/proceso-compra/login/");
  if (Object.keys(productoSeleccionado).length === 0) props.history.push("/hoteles/listado-de-hoteles/");
  const token = sessionStorage.getItem("token");
  
  const [tiposDocumento, setTiposDocumento] = useState([]);
  const [nacionalidades, setNacionalidades] = useState([]);
  const [loaded, setLoaded] = useState(true);


  useEffect(() => {
    if (!isLogged() || Object.keys(productoSeleccionado).length === 0) return;

    const data1 = JSON.stringify({ accion: "tiposDeDocumento" });
    toolsAPI(data1).then((respuesta) => {
      if (manejadorDeRespuesta(props, respuesta))
        setTiposDocumento(respuesta.data);
    });

    const data2 = JSON.stringify({ accion: "paises" });
    toolsAPI(data2).then((respuesta) => {
      if (manejadorDeRespuesta(props, respuesta))
        setNacionalidades(respuesta.data);
      setLoaded(false);
    });

    const data3 = JSON.stringify({
      peticion: 'tomarOfertasParaStockEnDemanda', 
      token,
      producto: productoSeleccionado,
      fechaIn: busquedaCDR.fechaIn,
      fechaOut: busquedaCDR.fechaOut
    })
    cdrAPI(data3).then((respuesta) => {
      if (manejadorDeRespuesta(props, respuesta))
        dispatch({type: SET_CDR_OFERTAS, payload: respuesta.data })
      });
  }, []);

  const handlePasajeroAdultoChange = (indice, propiedad, valor) => {
    dispatch({type: SET_PASAJEROS_ADULTOS, payload: { indice, propiedad, valor }});
  };

  const handlePasajeroMenorChange = (indice, propiedad, valor) => {
    dispatch({type: SET_PASAJEROS_MENORES, payload: { indice, propiedad, valor }});
  };

  const validarPlanFamily = (adultos, menores, habitaciones = []) => {
    let result = false;
    habitaciones.forEach(hab => {
      if (hab.tipoDeHabitacion.capacidadTipo === 4 && adultos.length >= 2 && menores.length >= 2) {
        result = true;
      }
      if (hab.tipoDeHabitacion.capacidadTipo === 3 && adultos.length >= 2 && menores.length >= 1) {
        result = true;
      }
    })

    return result;
  };

  const validarEdadMenores = (pasajeros) => {
    let rto = true;
    pasajeros.forEach(function (unPasajero) {
      let edad = calcularEdad(unPasajero.fechaNacimiento);
      if (edad >= 9) {
        rto = false;
      }
    });
    return rto;
  };
  
  const validarEdadAdultos = (pasajeros) => {
    let rto = true;
    pasajeros.forEach(function (unPasajero) {
      let edad = calcularEdad(unPasajero.fechaNacimiento);
      if (edad < 9) {
        rto = false;
      }
    });
    return rto;
  };

  const handlePasoPagarClick = (e) => {
    e.preventDefault();

    if (
      !validarDatosPasajeros(pasajerosAdultos) ||
      !validarDatosPasajeros(pasajerosMenores)
    ) {
      toast.error("Debe completar todos los campos de los pasajeros", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      return;
    }

    if (!validarEdadAdultos(pasajerosAdultos)) {
      toast.error("Los adultos deben ser mayores de 8 años", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      return;
    }
    
    if (!validarEdadMenores(pasajerosMenores)) {
      toast.error(
        "Los menores no pueden ser mayores de 8 años",
        {
          position: toast.POSITION.BOTTOM_CENTER,
        }
      );
      return;
    }
    const habitConPlanFamily = productoSeleccionado.habitaciones.filter(hab => get(hab, 'tipoDeHabitacion.nombreTipo', '').includes('FAMILY'));
    if (habitConPlanFamily.length > 0) {
      if (!validarPlanFamily(pasajerosAdultos, pasajerosMenores, habitConPlanFamily)) {
        toast.error(
          "Los pasajeros no tienen la edad correcta para tener una habitacion del tipo Family",
          {
            position: toast.POSITION.BOTTOM_CENTER,
          }
        );
        return;
      }
    }
    
    props.history.push("/hoteles/proceso-compra/pago/");
  };

  /*
  if (cdrOfertas.length === 0) {
    return (
      <LayoutCompra paso="2">
        <div className="result" style={{margin: '50px'}}>
          <h4>Lamentamos informarle que actualmente no hay ofertas disponibles para el criterio seleccionado. 
            Por favor vuelve a intentar con fechas o tipo de habitación distintas.</h4>
          <h5>Gracias y disculpe las molestias.</h5>
        </div>
      </LayoutCompra>
    )
  }
  */
  return (
    <LayoutCompra paso="2">
      <div>
        <LoaderFormal loaded={loaded} />
        <div className="title">
          <h2>Datos de los pasajeros </h2>
          <p>
            <sup>*</sup> Datos obligatorios
          </p>
          <hr />
        </div>
        <p className="parrafoCargaPasajeros">
          Pasajeros: {pasajerosAdultos.length} Adultos y{" "}
          {pasajerosMenores.length} Menores. Para cambiar la cantidad de
          pasajeros, realice una nueva busqueda desde el paso previo
        </p>
        {pasajerosAdultos.map((pasajero, clave) => {
          return (
            <PasajeroFormulario
              key={clave}
              numero={clave}
              pasajero={pasajero}
              onPasajeroChange={handlePasajeroAdultoChange}
              tiposDeDocumento={tiposDocumento}
              nacionalidades={nacionalidades}
            />
          );
        })}

        {pasajerosMenores.map((pasajero, clave) => {
          return (
            <PasajeroFormulario
              key={clave}
              numero={clave}
              pasajero={pasajero}
              onPasajeroChange={handlePasajeroMenorChange}
              tiposDeDocumento={tiposDocumento}
              nacionalidades={nacionalidades}
            />
          );
        })}
        <input
          type="submit"
          value="continuar"
          className="submitCargaPasajeros"
          onClick={handlePasoPagarClick}
        />
      </div>
    </LayoutCompra>
  );
};

export default withRouter(CargaPasajerosCdr);




// WEBPACK FOOTER //
// ./src/components/Hoteles/ProcesoCompraCdr/CargaPasajerosCdr/index.js